import React from "react";
import { Box, Flex, Text, Button, Image, Link, useBreakpointValue, Heading, HStack } from "@chakra-ui/react";
import { MainLogo, Rect, SophieLogo, WebLogoMain } from "../utils/Images";
import { useNavigate } from "react-router-dom";
import Arc from "../assets/arc.svg"

const HeroSection = () => {
  const navigate = useNavigate();
  const isMobile = useBreakpointValue({ base: true, md: false });

  return (
    <Box
      minH={{ base: "80vh", md: "100vh" }}
      w="100%"
      bg="#f7fcfd"
      bgImage={{ base: undefined, md: undefined }} // Add background image here if needed
      bgSize="cover"
      bgRepeat="no-repeat"
      display="flex"
      flexDirection="column"
      alignItems="stretch"
    >
      {/* Navigation */}
      <Flex
        w="100%"
        justify="space-between"
        align="center"
        pt={{ base: 6, md: 10 }}
        px={{ base: 4, md: 16 }}
      >
        <HStack spacing={3}>
          <Image src={SophieLogo} alt="Sophie Care" boxSize="40px" display={{ base: 'block', md: 'none' }} />
          <Image src={MainLogo} alt="Sophie Care" h="60px" w="200px" display={{ base: 'none', md: 'block' }} />
        </HStack>
        <Flex align="center" gap={{ base: 3, md: 4 }}>
          <Text
            color="#008080"
            fontWeight="400"
            fontSize={{ base: "12px", md: "15px" }}
            cursor="pointer"
            mb={0}
            onClick={() => navigate("/login")}
          >
            Login
          </Text>
          <Button
            colorScheme="brand"
            bg="brand.500"
            color="white"
            borderRadius="full"
            w={{ sm: '160px', md: 'auto' }}
            px={6}
            fontWeight="semibold"
            _hover={{ bg: "brand.600" }}
            fontSize={{ base: '12px !important', md: "16px" }}
            onClick={() => {
              navigate('/onboarding')
            }}
          >
            Start free 30 days trail
          </Button>
        </Flex>
      </Flex>

      {/* Hero Content */}
      <Flex
        direction="column"
        align="center"
        justify="center"
        w="100%"
        maxW="80vw"
        mx="auto"
        pt={{ base: 6, md: 16 }}
        px={2}
      >
        <Heading variant="headline" textAlign="center">
          Because every loved one deserves to
          <br display={isMobile ? "none" : "inline"} />
          feel cared for and connected
        </Heading>
        <Text variant="subtitle" textAlign="center">
          <Text as="span" color="brand.500" fontSize={["20px", "32px"]}>Gentle, friendly</Text> phone calls that <Text as="span" color="brand.500" fontSize={["20px", "32px"]}>bring joy, fight loneliness</Text>,
          <br display={isMobile ? "none" : "inline"} />
          and help keep the <Text as="span" color="brand.500" fontSize={["20px", "32px"]}>mind active</Text> — with updates for families and caregivers
        </Text>
        <Button
          px="30px"
          onClick={() => {
            navigate('/onboarding')
          }}        >
          Learn more
        </Button>
        <Text
          variant="paragraph"
          textAlign="center"
          mt="20px"
        >
          Already have an account?{' '}
          <Box
            as="span"
            color="#008080"
            textDecoration="underline"
            cursor="pointer"
            onClick={() => navigate("/login")}
          >
            Sign in
          </Box>
        </Text>
      </Flex>
      <Image src={Rect} maxH="70px" mt={["20px", "100px"]} />
    </Box>
  );
};

export default HeroSection; 